/** Two small, clearly-labelled sets rather than one big dump — enough range to
 * feel like you, not a wall of icons to scroll through. */
export const FACE_EMOJIS = ['😎', '😊', '🙂', '🥳', '🤩', '😇', '🥰', '🤪', '😜', '😌', '🫠', '🤔'];
export const VIBE_EMOJIS = [
  '✨',
  '🔥',
  '🎧',
  '🫶',
  '👀',
  '🌙',
  '🎨',
  '⚡',
  '🍓',
  '🛼',
  '📸',
  '🌈',
  '🦋',
  '🍄',
  '🌊',
  '🎮',
];
